export const OPEN_WIDGETS = 'OPEN_WIDGETS'
export const UDATE_WIDGETWIDTH = 'UDATE_WIDGETWIDTH'
export const TRANSFER_COUNT = 'TRANSFER_COUNT'
export const SET_USER_WIDGETS = 'SET_USER_WIDGETS'
export const SALES_CIP = 'SALES_CIP'
export const SET_RU_WIDGET = 'SET_RU_WIDGET'
export const SET_RU_WIDGET_SHOW = 'SET_RU_WIDGET_SHOW'
export const  SET_RU_EXPANDED = 'EXPANDED_VIEW'

